import styled from "styled-components";

export const ManageIssuesWrapper = styled.div``;